import React from "react";
import localeText from "../../../../../../locale";
import { Dialog } from "primereact/dialog";
import { Rating } from "primereact/rating";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";

const RatingModal = ({
  displayRateVisible,
  loading,
  setRatingProduct,
  setRatingSeller,
  setComment,
  setDisplayRateVisible,
  ratingProduct,
  ratingSeller,
  comment,
  commentProductService,
  setCommentProductService,
  orderRate,
}) => {
  return (
    <Dialog
      header={localeText("rateOrder")}
      visible={displayRateVisible}
      onHide={() => {
        if (!loading) {
          setRatingProduct(null);
          setRatingSeller(null);
          setComment("");
          setDisplayRateVisible(false);
        }
      }}
      breakpoints={{ "960px": "85vw" }}
      draggable={false}
      style={{ width: "50vw" }}
    >
      <label htmlFor="rating" className="font-bold">
        {localeText("rateProduct")}
      </label>
      <Rating value={ratingProduct} onChange={(e) => setRatingProduct(e.value)} className="my-2" />
      <label htmlFor="rating" className="font-bold">
        {localeText("rateSeller")}
      </label>
      <Rating
        value={ratingSeller}
        onChange={(e) => setRatingSeller(e.value)}
        className="mt-2 mb-4"
      />

      <label htmlFor="comment" className="font-bold">
        {localeText("comment")} ({localeText("optional")})
      </label>
      <InputTextarea
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        rows={5}
        cols={40}
        className="w-full mt-2 mb-4"
        style={{ resize: "none" }}
        maxLength={1000}
      />

      <label htmlFor="comment" className="font-bold">
        {localeText("commentProductService")} ({localeText("optional")})
      </label>
      <InputTextarea
        value={commentProductService}
        onChange={(e) => setCommentProductService(e.target.value)}
        rows={5}
        cols={40}
        className="w-full mt-2 mb-4"
        style={{ resize: "none" }}
        maxLength={1000}
      />

      <Button
        label={localeText("confirmRating")}
        className="my-2"
        onClick={() => orderRate()}
        loading={loading}
      />
    </Dialog>
  );
};

export default RatingModal;
